import { useEffect, useRef } from "react";
import { useTimer } from "react-timer-hook";

function Timer({ expiryTimestamp, onExpire, enableUi }) {
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp,
    onExpire: onExpire,
  });

  const restartRef = useRef(restart);

  useEffect(() => {
    // restart if expiry time changed
    console.warn(`Timer() reset`);
    restartRef.current(expiryTimestamp);
  }, [restartRef, expiryTimestamp]);

  if (enableUi) {
    return (
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "20px" }}>
          <span>{minutes}</span>:<span>{seconds}</span>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default Timer;
